import React from "react";
import './WegZuLernen.css';

class WegZuLernen extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">طرق تعلم اللغة الألمانية </legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        متضعيش وقتك وابدا النهارده قبل بكره واتعلم لغه حتي لو مش ناوي تسافر دلوقتي  وحتي لو لا  قدر الله مسافرتش يبقي معاك لغه تخليك تشتغل بمرتب محترم يعيشك حلو 
                                        <br/>
                                        <br/>
                                        -:هحط شويه لينكات كبدايه ليك
                                        <hr/>
                                        <a target='_blank' rel='noreferrer' href='https://m.youtube.com/watch?v=P6H_HQPqM5Q'>اسلوب مقترح للدراسه</a>
                                        <hr/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/460149804363745/'>بعض تجارب تعلم اللغة</a>
                                        <hr/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/463390280706364'>افضل المدرسين العرب للغة الألمانية على اليوتيوب و تعلم اللغة ذاتيا</a>
                                        <hr/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/512042582507800/'>مجموعة للكورسات الصوتية و المسلسلات و الأفلام لتعلم اللغة</a>
                                        <hr/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/405841603127899'>B1 تجارب امتحان</a>
                                        <hr/>
                                        <a target='_blank' rel='noreferrer' href='https://m.dw.com/en/learn-german/deutsch-interaktiv/s-9572'>DW كورس الماني من موقع</a>
                                        <hr/>
                                        #Menschen
                                        <br/>
                                        B1 لحد A1 من
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://drive.google.com/drive/u/0/folders/1cw2L3uttohQr_mChmkF126CQVJ8n9W0z'>PDF صوتيات و فيديوهات و الكتاب</a>
                                        <br/>
                                        <br/>
                                        كلمات المستوى الاول و الثانى و الثالث
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.file-upload.com/6jwb7i3gqojg'>Menschen Glossar A1</a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.file-upload.com/2fnj7zwc7v8o'>Menschen Glossar A2</a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.file-upload.com/mjukurthmvys'>Menschen Glossar B1</a>
                                        <hr/>
                                        أهم المواقع المجانية لممارسة وتعلم اللغة الألمانية
                                        <br/>
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://www.goethe.de/de/spr/ueb.html'>goethe.de/de/spr/ueb.html</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.deutschakademie.de/online-deutschkurs/'>deutschakademie.de/online-deutschkurs</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://deutschtraining.org'>deutschtraining.org</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.deutsch-lernen-online.net'>deutsch-lernen-online.net</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.dw.com/de/deutsch-lernen/deutschkurse/s-2068'>dw.com/de/deutsch-lernen/deutschkurse/s-2068</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.aufgaben.schubert-verlag.de'>aufgaben.schubert-verlag.de</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://deutsch.info/de'>deutsch.info/de</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://online-lernen.levrai.de'>online-lernen.levrai.de</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.alumniportal-deutschland.org/deutsche-sprache/online-deutsch-lernen/videos-und-interaktive-uebungen.html'>alumniportal-deutschland.org/deutsche-sprache/online-deutsch-lernen/videos-und-interaktive-uebungen.html</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://sprachportal.integrationsfonds.at'>sprachportal.integrationsfonds.at</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.grammatikdeutsch.de'>grammatikdeutsch.de</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.hauptstrasse117.uni-jena.de/en/'>hauptstrasse117.uni-jena.de</a>
                                            <br/>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://www.siebern.de/Deutsch.html'>siebern.de/Deutsch.html</a>
                                        </div>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default WegZuLernen;
